<template>
  <div class="d-flex flex-column justify-center text-center align-center">
    <v-icon :size="iconSize" color="blue-grey lighten-1" large>
      {{ icon }}
    </v-icon>
    <p
      class="ma-0 pa-0 subtitle-2 blue-grey--text text--darken-1 text-center mt-3 mb-1"
      style="max-width: 300px;"
    >
      {{ title }}
    </p>
    <p class="ma-0 pa-0 blue-grey--text caption mb-3" style="max-width: 250px;">
      {{ message }}
    </p>
    <p
      v-if="buttonSubtitle"
      class="ma-0 pa-0 blue-grey--text caption mb-0"
      style="max-width: 250px;"
    >
      {{ buttonSubtitle }}
    </p>
    <Button
      v-if="buttonText"
      color="primary"
      :data-testid="buttonTestId"
      :data-tourid="buttonTourId"
      :text="buttonText"
      @click="$emit('click')"
    />
  </div>
</template>

<script>
import Button from '@/components/UI/Button.vue'

export default {
  name: 'EmptyState',
  components: {
    Button,
  },
  props: {
    title: {
      type: String,
      default() {
        return this.$t('common.there_are_not_results_to_show')
      },
    },
    icon: {
      type: String,
      default() {
        return 'mdi-ghost-outline'
      },
    },
    buttonSubtitle: {
      type: String,
    },
    iconSize: {
      type: Number,
      default: 24,
    },
    message: String,
    buttonText: String,
    buttonTestId: String,
    buttonTourId: String,
  },
}
</script>
